import React from "react";
import "../styles/CustomThreadHeader.css";
import { isValidPhotoUrl } from "../utils/validationUtils";
import { getInitials } from "../utils/stringUtils";
// Function to get initials if the image is not available
 

const CustomThreadHeader = ({ closeThread, thread }) => {
  const replyCount = thread.reply_count ?? 0;
  const threadParticipants = thread.thread_participants ?? [];
 
  return (
    <div className="wrapper">
      <div className="participants-wrapper">
        {threadParticipants.map((participant, index) => (
          <div className="participant" key={index}>
            {/* Custom Avatar or Initials */}
            <div className="avatar-container">
              <div className="avatar">
                {participant.photo && isValidPhotoUrl(participant.photo) ? (
                  <img src={participant.photo} alt={participant.name} />
                ) : (
                  <div className="initials-circle">
                    {!participant.photo &&
                      getInitials(
                        participant.firstName + " " + participant.lastName
                      )}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
        <div className="reply-count">{replyCount} Replies</div>
      </div>
      <div onClick={closeThread} className="close-button">
      <span style={{ fontSize: '20px', color: '#333' }}>✖️</span>
      </div>
    </div>
  );
};
export default CustomThreadHeader;
